import { createSelector } from "reselect";
import { IApplicationState } from "src/~store/models/ApplicationState";

const auditSelector = (state: IApplicationState) => state.auditState;

const auditListSelector = createSelector(auditSelector, (auditState) => auditState.auditList);

export const isReceivingAuditsSelector = createSelector(
    auditListSelector, 
    (auditList) => auditList.isReceivingAudits
);

export const auditsSelector = createSelector(
    auditListSelector, 
    (auditList) => auditList.audits
);

export const auditTagsSelector = createSelector(
    auditListSelector, 
    (auditList) => auditList.auditTags
);

export const auditOperatorsSelector = createSelector(
    auditListSelector, 
    (auditList) => auditList.operators
);